import { IPaymentLink, IPaymentLinkData } from './types';

export const normalizePaymentLink = (data: IPaymentLinkData): IPaymentLink => {
  return {
    amount: data?.amount as number,
    countryCode: (data?.countryCode as string) || '',
    created: (data?.created as string) || '',
    currency: (data?.currency as string) || '',
    description: (data?.description as string) || '',
    emailFrom: (data?.emailFrom as string) || '',
    enabled: !!(data?.enabled as string),
    fullPaymentLink: (data?.fullPaymentLink as string) || '',
    id: (data?.id as number) || 0,
    merchantTerminal: {
      id: (data?.merchantTerminal?.id as number) || 0,
    },
    paymentMethod: (data?.paymentMethod as string) || '',
    sendResultEmail: !!data?.sendResultEmail,
    terminalLink: {
      id: (data?.terminalLink?.id as number) || null,
    },
    trackRepeatingCustomers: !!data?.trackRepeatingCustomers,
    transactionDescription: (data?.transactionDescription as string) || '',
    updated: (data?.updated as string) || '',
  };
};
